<div class="login">
  <div class="login__content">
    <div class="login__loader" [ngClass]="{'login__loader--is-loading': this.isLoading}">
      <app-loader />
    </div>
    <div class="login__logo">
      <svg
        id="Calque_1_3_"
        xmlns="http://www.w3.org/2000/svg"
        width="140.09"
        height="53.256"
        viewBox="0 0 140.09 53.256"
      >
        <path
          id="Tracé_1"
          data-name="Tracé 1"
          d="M105.067,125.231v-4.048h2.588v-2.671h-2.588v-3.36H101.5v3.36H99.7v2.671H101.5v4.841c0,3.777,2.316,3.986,4.007,3.986a15.211,15.211,0,0,0,2.4-.188v-2.755a11.933,11.933,0,0,1-1.294.063C105.714,127.151,105.067,126.9,105.067,125.231Zm-10.893-5.092a4.069,4.069,0,0,0-3.443-1.9c-3.255,0-5.53,2.567-5.53,5.948s2.254,5.947,5.53,5.947a4.045,4.045,0,0,0,3.443-1.878v1.607h3.589V118.533H94.173Zm-2.692,6.928a2.886,2.886,0,1,1,2.692-2.88A2.718,2.718,0,0,1,91.481,127.068Zm24.291-3.9c-1.9-.626-2.88-.772-2.88-1.607,0-.689.605-1,1.336-1a1.333,1.333,0,0,1,1.482,1.482h3.548c0-2.17-1.607-3.819-4.883-3.819-3.047,0-5.008,1.106-5.008,3.443,0,2.191,1.628,2.734,3.506,3.318,2.129.71,3.026.814,3.026,1.69,0,.751-.605,1.064-1.482,1.064-1.064,0-1.816-.48-1.816-1.669h-3.527c0,2.609,2,4.09,5.217,4.09,2.817,0,5.113-.96,5.113-3.631C119.4,124.292,117.776,123.75,115.772,123.165Zm7.241-9.412h2.17V87.313h-2.17Zm6.365,5.2h2.17V82.117h-2.17Zm33.995-21.223H161.2v5.593h2.17Zm-6.365-5.2h-2.17v16.006h2.17Zm-44.554,5.2h-2.17v5.593h2.17Zm6.365-5.2h-2.17v16.006h2.17Zm80.656,37.313H201V119.43h-1.523Zm.751-15.9a1.391,1.391,0,0,0-1.377,1.44,1.363,1.363,0,0,0,1.377,1.377,1.409,1.409,0,1,0,0-2.817Zm-6.177,7.7A4.369,4.369,0,0,0,190,119.2a5.447,5.447,0,0,0,0,10.893,4.4,4.4,0,0,0,4.048-2.442v2.191h1.523V113.4H194.05Zm-3.965,7.033a4.06,4.06,0,1,1,3.965-4.048A3.883,3.883,0,0,1,190.085,128.675Zm31.845-4.528c-2-.543-3.151-.73-3.151-1.982,0-1.106.96-1.732,2.316-1.732,1.565,0,2.546.772,2.546,2.212h1.5c0-2.129-1.732-3.443-4.007-3.443-2.212,0-3.861,1.043-3.861,2.963,0,1.941,1.44,2.4,3.151,2.817,2,.563,3.422.73,3.422,2.087,0,1.148-.939,1.753-2.483,1.753-1.649,0-2.922-.668-2.922-2.5h-1.5c0,2.609,2,3.777,4.341,3.777,2.421,0,4.007-1.064,4.007-3.047C225.311,125,223.662,124.584,221.93,124.146Zm-41.779.626c0,1.92-1.127,3.944-3.422,3.944-2.17,0-3.005-1.565-3.005-3.61v-5.655H172.18v6.094a4.863,4.863,0,0,0,.918,3.235,3.892,3.892,0,0,0,3.13,1.315,4.117,4.117,0,0,0,3.944-2.5v2.254H181.7V119.43h-1.523v5.342Zm29.258-5.572a5.447,5.447,0,1,0,5.488,5.447A5.3,5.3,0,0,0,209.409,119.2Zm0,9.474a4.06,4.06,0,1,1,3.965-4.048A3.883,3.883,0,0,1,209.409,128.675Zm-50.752-4.528c-2-.543-3.151-.73-3.151-1.982,0-1.106.96-1.732,2.316-1.732,1.565,0,2.546.772,2.546,2.212h1.5c0-2.129-1.732-3.443-4.007-3.443-2.212,0-3.861,1.043-3.861,2.963,0,1.941,1.44,2.4,3.151,2.817,2,.563,3.422.73,3.422,2.087,0,1.148-.939,1.753-2.483,1.753-1.649,0-2.922-.668-2.922-2.5h-1.5c0,2.609,2,3.777,4.341,3.777,2.421,0,4.007-1.064,4.007-3.047C162.037,125,160.368,124.584,158.657,124.146Zm8.2,1.9v-5.3h3.005V119.43h-3.005v-3.861h-1.544v3.861h-2.087v1.315h2.087v5.614c0,3.339,1.816,3.61,3.172,3.61a10.016,10.016,0,0,0,1.753-.146v-1.377a10.875,10.875,0,0,1-1.461.125C167.672,128.57,166.858,128.278,166.858,126.045Zm-24.75-7.1h2.17V82.117h-2.17Zm6.365-5.2h2.191V87.313h-2.191Zm-12.73,10.413h2.17V76.9h-2.17Z"
          transform="translate(-85.2 -76.9)"
        />
      </svg>
    </div>
    <div class="login__contentwrapper" [ngClass]="{'login__contentwrapper--is-loading': this.isLoading}">
      <h1 class="display-6 text-center">
        Saisissez votre nouveau mot de passe
      </h1>
      @if (!this.isSuccess) {
<form class="login__form form-group" [formGroup]="this.passwordForm">
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            name="newPassword"
            id="newPassword"
            placeholder=""
            formControlName="newPassword"
            (change)="this.isSubmitted = false"
            [ngClass]="{
            'is-invalid': this.newPasswordInput?.invalid && this.isSubmitted
          }"
          />
          <label for="newPassword">Nouveau mot de passe</label>
        </div>
        @if (newPasswordInput?.invalid && (newPasswordInput?.dirty || newPasswordInput?.touched)) {
<div id="passwordValidation" class="text-center small" style="color: #952626">
          @if (newPasswordInput?.errors?.['required']) {
<div>Champs requis !</div>
}
          @if (newPasswordInput?.errors?.['minlength']) {
<div>Le mot de passe doit contenir au minimum 8 caractères.</div>
}
          @if (newPasswordInput?.errors?.['pattern']) {
<div>Le mot de passe doit contenir au minimum 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial ($, &#64;, !, %, *, ?, &, #, €, |, ç, _, -)</div>
}
        </div>
}
        <div class="form-floating mt-3 mb-3">
          <input
            type="password"
            class="form-control"
            name="confirmPassword"
            id="confirmPassword"
            placeholder=""
            formControlName="confirmPassword"
            (change)="this.isSubmitted = false"
            [ngClass]="{
            'is-invalid': this.confirmPasswordInput?.invalid && this.isSubmitted
          }"
          />
          <label for="confirmPassword">Ressaisissez votre mot de passe</label>
        </div>
        <button type="submit" class="btn btn-dark w-100" [disabled]="!passwordForm.valid || isSubmitted" (click)="this.resetPassword()">
          Appliquer le nouveau mot de passe
        </button>
      </form>
}
      @if (this.isSuccess) {
<div class="text-center">
        Votre demande de réinitialisation de mot de passe à bien été envoyé. Vous recevrez un lien par email dans quelques instants qui vous permettra de définir un nouveau mot de passe.
        <button type="submit" class="btn btn-dark w-100 mt-4" (click)="this.router.navigate(['/login'])">
          <i class="fa-solid fa-arrow-left"></i>
          Retourner sur la page de connexion
        </button>
      </div>
}
    </div>
    <div class="login__footer">
      © ATS Studios 2023
    </div>
  </div>
  <div class="login__illustration"></div>
</div>
